import React, { useContext, useEffect, useState } from 'react'
import ExpoLibrary from './ExpoLibrary'
import Loading from '../../components/Loading'
import CustomModal from '../../components/Modal/CustomModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight, faEnvelopeOpen, faLocationDot, faSquarePhone } from '@fortawesome/free-solid-svg-icons'
import { store } from '../../components/HOC/State'
import { translate } from '../translate'
import { axiosInstance } from '../../const/axiosInstance'
import { Parser } from 'html-to-react'
import { BACKEND_URL } from '../../const/Constant'
import styles from './expo.module.css'

export default function ExpoPlaces() {
  const [arr, setArr] = useState([])
  const [expoText, setExpoText] = useState("")
  const [loading, setLoading] = useState(false)
  const [updateed, setUpdated] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [openedIndex, setOpenedIndex] = useState(0)
  const {offset, setOffset, setOffsetUpdated, selectedLang} = useContext(store)
  const limit = 20

  let lang = translate[selectedLang]

  const htmlParser = new Parser()

  useEffect(() => {
    setOffset(0)
    setUpdated(true)
  }, [])


  const close = () => {
    setShowModal(false)
}

  useEffect(() => {
      (
          async () => {
              const res = await axiosInstance.get(`/use/expo-text`)
              if(res.data.status){
                  setExpoText(res.data.data)
              }else{
                  setExpoText("")
              }
          }
      )()

  }, [])

  const slideLeft = () => {
    if(openedIndex){
      setOpenedIndex(p => p - 1)
    }else{
      setOpenedIndex(arr.length - 1)
    }
  }

  const slideRight = () => {
    if(openedIndex != arr.length - 1){
      setOpenedIndex(p => p + 1)
    }else{
      setOpenedIndex(0)
    }
  }

  useEffect(() =>{ 
    (async() => {
      if(updateed){
        setLoading(true)
        const res = await axiosInstance.get(`/use/expo/library?offset=${offset}&limit=${limit}`)
        if(res.data.status){
          setArr([...arr,...res.data.data])
          if(res.data.data.length === 20){
            setOffsetUpdated(false)
          }
        }else{
          setArr([...arr])
        }
        setLoading(false)
      }
    })()
  }, [offset, updateed])


  return (
    <div className={styles['main-expo-places']}>
        <div className={styles['contact-div']}>
            <div className={styles['contact-part-div']}>
                <FontAwesomeIcon className={styles['contact-part-icon']} icon={faSquarePhone} />
                <p className={styles['contact-part-title']}>{lang.tr_telephone}</p>
                <p>+37415 27 27 00</p>
            </div>
            <div className={styles['contact-part-div']}>
                <FontAwesomeIcon className={styles['contact-part-icon']} icon={faEnvelopeOpen} />
                <p className={styles['contact-part-title']}>{lang.tr_mail}</p>
                <a href='mailto: sc@mergelyan.com'>sc@mergelyan.com</a>
            </div>
            <div className={styles['contact-part-div']}>
                <FontAwesomeIcon className={styles['contact-part-icon']} icon={faLocationDot} />
                <p className={styles['contact-part-title']}>{lang.tr_address}</p>
                <p>{lang.tr_address2}</p>
            </div>
        </div>
        <div className={`${styles['images-div']} ${styles['expo-descr-text']}`}>
            {htmlParser.parse(expoText[`${selectedLang}text`]?.
                                replaceAll(`iframe width="auto" height="auto"`, `iframe width="${0.6*window.innerWidth}" height="${0.6*window.innerWidth/1.6}" allowfullscreen`).
                                replaceAll("alt=\"undefined\" style=\"height: auto;width: auto\"/>", `alt="undefined" "height="auto" width="${0.6*window.innerWidth}"/>`))
            }
        </div>
        <div >
          {arr.length ? 
            <div className={styles['images-div']}>
                {arr.map((el, i) => <ExpoLibrary key={el._id} el={el} setShowModal={setShowModal} index={i} setOpenedIndex={setOpenedIndex}/>)}
                {loading ? <Loading width={200}/> : ""}
            </div>
            : 
            !loading ? <p className='empty-message'>{lang.tr_noPublished}</p> : null 
          }
          {showModal && 
              <CustomModal close={close}>
                  <img src={BACKEND_URL + arr[openedIndex].image} alt='expo-image'/>
                  <div className={styles['control-div']}>
                    <div onClick={slideLeft} className={`${styles['left']} ${styles['control-btn']}`}>
                        <FontAwesomeIcon className={styles['control-icon']} icon={faAngleLeft} />
                    </div>
                    <div onClick={slideRight} className={`${styles['right']} ${styles['control-btn']}`}>
                        <FontAwesomeIcon className={styles['control-icon']} icon={faAngleRight} />
                    </div>
                </div>
              </CustomModal>}
        </div>
    </div>
  )
}
